import { joinClassNames } from '@vertex-protocol/web-common';

export type NadoDepositMethod = 'stablecoin' | 'ewallet';

interface Props {
  activeMethod: NadoDepositMethod;
  onMethodChange: (method: NadoDepositMethod) => void;
}

const METHODS: {
  method: NadoDepositMethod;
  label: string;
}[] = [
  { method: 'stablecoin', label: 'Stablecoin' },
  { method: 'ewallet', label: 'E-Wallet' },
];

export function NadoDepositMethodTabs({
  activeMethod,
  onMethodChange,
}: Props) {
  return (
    <div
      className="bg-surface-2 grid grid-cols-2 rounded-sm p-1"
      role="tablist"
      aria-label="Deposit method"
    >
      {METHODS.map(({ method, label }) => {
        const isActive = activeMethod === method;
        return (
          <button
            key={method}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onMethodChange(method)}
            className={joinClassNames(
              'rounded-sm px-3 py-2 text-sm font-medium transition-colors',
              isActive
                ? 'bg-surface-card text-text-primary'
                : 'text-text-tertiary hover:text-text-secondary',
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
